'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Job;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getMatch = function getMatch(match, hasMatched) {
  if (!hasMatched) {
    return 'Match Me';
  } else if (match > 0.5) {
    return (match * 100).toFixed(0) + '%';
  }

  return null;
};

function Job(_ref) {
  var match = _ref.match,
      salary = _ref.salary,
      title = _ref.title,
      slug = _ref.slug,
      hasMatched = _ref.hasMatched,
      matchMe = _ref.matchMe;

  var className = '';
  if (!hasMatched) {
    className = 'no-match';
  } else if (match >= 0.70) {
    className = 'large';
  } else if (match >= 0.50) {
    className = 'medium';
  } else if (match >= 0.40) {
    className = 'small';
  } else {
    className = 'empty';
  }

  var formattedSalary = salary.replace(/-/g, '‑');

  return _react2.default.createElement(
    'div',
    { className: 'job' },
    _react2.default.createElement(
      'div',
      { className: className + ' job-match' },
      _react2.default.createElement(
        'div',
        { className: 'c-tooltip black down' },
        formattedSalary,
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'a',
            { href: '/job/' + slug },
            title
          )
        )
      ),
      _react2.default.createElement(
        'span',
        {
          onClick: function onClick() {
            if (!hasMatched) {
              matchMe(true);
            }
          }
        },
        getMatch(match, hasMatched)
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/RolesAndEducation/Job.jsx
// module id = 1260
// module chunks = 0